import * as React from 'react';

function SvgUserCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M12 1a11 11 0 110 22 11 11 0 010-22zm0 14.7c-1.97 0-3.63.62-4.7 1.57-.4.36-.68.73-.78 1.02l-.01.02.2.18a8 8 0 004.96 1.8l.33.01a8.1 8.1 0 005.3-1.82l.2-.18-.02-.01a2.6 2.6 0 00-.63-.88l-.15-.14A7.06 7.06 0 0012 15.7zm0-12.45a8.75 8.75 0 00-7.4 13.41c1.23-1.78 4.22-3.36 7.4-3.36 3.18 0 6.17 1.58 7.4 3.36A8.75 8.75 0 0012 3.25zm0 2c2.33 0 3 1.38 3 3s-1.25 4-3 4-3-2.38-3-4 .67-3 3-3z" />
    </svg>
  );
}

export default SvgUserCircle;
